<template>
  <div class="container">
    <h1 class="subs-title">List of Subscription Plans</h1>
    <p class="page-description">Add and manage your Subscriptions.</p>
    <main-button style="max-width: 244px; margin-bottom: 1rem" @click="$emit('createNewPlan')">
      <span class="add-symbol">+</span>Create new plan
    </main-button>
    <div v-if="!$apollo.loading" class="attendee_table">
      <div
        v-if="subscriptionPlans.length === 0"
        class="no-attendees-message-container border__left border__right"
      >
        <span class="no-attendees-message">No matching records found.</span>
      </div>
      <selected-items-header
        v-if="selected.length"
        :selected="selected"
        name="subscriber"
        @clear="selected = []"
        @delete="showDeleteDialog = true"
      />
      <table-list
        :selected.sync="selected"
        :organization-slug="organizationSlug"
        :attendees="subscriptionPlans"
        body-style="grid-auto-columns: 50px minmax(150px, 250px) !important;"
        :visible-fields="visibleFields"
        :attendee-fields="attendeeFields"
        :pagination="pagination"
        @click="$emit('editPlan', $event)"
        @sort="handleSort($event)"
      />
      <table-pagination
        :pagination="pagination"
        :total-attendees="totalSubscribersCount"
        @change="handlePagination($event)"
        @changePerPage="handlePagination($event)"
      />
    </div>
    <delete-dialog
      :content="`Are you sure you want to delete selected subscribers? This operation cannot be undone.`"
      :on-delete="handleDelete"
      :show.sync="showDeleteDialog"
      title="Delete subscribers"
    />
  </div>
</template>

<script>
import selectedItemsHeader from '@/components/tickets/selected-items-header.vue'
import deleteDialog from '../../shared/dialogs/delete-dialog.vue'
import tableList from '../../accreditations/attendee-table/list.vue'
import tablePagination from '../../accreditations/attendee-table/pagination.vue'

export default {
  name: 'subscription-plan-list',
  components: {
    deleteDialog,
    selectedItemsHeader,
    tableList,
    tablePagination,
  },
  props: {
    organizationSlug: {
      type: String,
    },
    initialValues: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const { pagination } = this.getInitialFromQueryParams()

    return {
      subscriptionPlans: this.initialValues,
      pagination,
      showDeleteDialog: false,
      openCreateModal: false,
      openUpdateModal: false,
      selected: [],
      attendeeFields: {},
      visibleFields: ['Name', 'Duration'],
      totalSubscribersCount: 0,
    }
  },
  methods: {
    handleDelete() {
      this.$emit('delete', this.selected)
      this.selected = []
    },
    async handlePagination({ page, per_page }) {
      const { page: currentPage, per_page: currentPerPage } = this.pagination
      if (currentPage > page && currentPage === 1) return
      if (page > currentPage && !(this.totalSubscribersCount - currentPerPage * currentPage > 0))
        return

      this.pagination = {
        ...this.pagination,
        per_page: per_page === 'All' ? -1 : per_page,
        page: page,
      }

      await this.addPaginationToRoute(this.pagination)
    },
    async handleSort(sortBy) {
      const { per_page, page, sortBy: thisSortBy, descending } = this.pagination
      const pagination = {
        page,
        per_page,
        sortBy,
        descending: sortBy === thisSortBy ? !descending : false,
      }
      await this.addPaginationToRoute(pagination)
      this.pagination = pagination
    },
    getInitialFromQueryParams() {
      const { per_page, page, sortBy, descending } = this.$route.query

      return {
        pagination: {
          page: parseInt(page, 10) || 1,
          per_page: parseInt(per_page, 10) || 10,
          sortBy: sortBy,
          descending: descending ? !!descending : false,
        },
      }
    },
    async addPaginationToRoute({ page, per_page, sortBy, descending }) {
      await this.$router.replace({
        query: {
          ...this.$route.query,
          per_page,
          page,
          sortBy,
          descending: descending ? 1 : 0,
        },
      })
    },
  },
}
</script>

<style scoped>
.page-description {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  color: #979797;
}
.container {
  padding: 0 !important;
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  max-width: 43.75rem;
}
.subs-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}
</style>
